import {
  apocalypse,
  diplodocus,
  lastSupper,
  statham,
  winter,
  carpet,
} from "../../assets/images";
import styles from "./StatusGallery.module.scss";
import { PreloadedImage } from "../../shared/components/PreloadedImage";

function StatusGallery() {
  return (
    <div className={styles.galleryContainer}>
      <div className={styles.leftColumn}>
        <PreloadedImage
          src={apocalypse}
          alt="Верхняя картина левой колонки"
          className={styles.leftTopImg}
          width={260}
          height={260}
        />
        <PreloadedImage
          src={winter}
          alt="Нижняя картина левой колонки"
          className={styles.leftBottomImg}
          width={188}
          height={212}
        />
      </div>
      <div className={styles.centerColumn}>
        <PreloadedImage
          src={carpet}
          alt="Настенный ковер"
          className={styles.centerImg}
          width={836}
          height={531}
        />
      </div>
      <div className={styles.rightColumn}>
        <PreloadedImage
          src={lastSupper}
          alt="Верхняя картина правой колонки"
          className={styles.rightImg}
          width={284}
          height={164}
        />
        <PreloadedImage
          src={diplodocus}
          alt="Средняя картина правой колонки"
          className={styles.rightImg}
          width={195}
          height={233}
        />
        <PreloadedImage
          src={statham}
          alt="Нижняя картина правой колонки"
          className={styles.rightImg}
          width={147}
          height={175}
        />
      </div>
    </div>
  );
}

export default StatusGallery;
